import React, { FunctionComponent } from 'react';
import './Snackbar.scss';

interface ISnackbar {
    toastMessage: string;
}

export const Snackbar: FunctionComponent<ISnackbar> = (props) => {
    return (
        <>
            <div className="fi-toast__snackbar">
                {props.toastMessage}
            </div>
        </>
    );
};